import createDecorator from './createDecorator'

import { DecoratorComponent } from '@peracto/peracto-blocks-tailwind'
import { DecoratorComponent as BlockDecoratorComponent } from '@peracto/peracto-blocks-tailwind'
import Form from './Form'
import BlockFormDecoratorComponent from './Form'

import decoratePlugins from './helper/decoratePlugins'

const createPluginDecorator = settings =>
    createDecorator({
        DecoratorComponent: DecoratorComponent,
        DecoratorFormComponent: Form,
        decoratePlugins,
        ...settings,
    })

const decorator = createPluginDecorator()
export default decorator

export { createPluginDecorator, BlockDecoratorComponent, BlockFormDecoratorComponent }
